<template>
  <div class="container">
    <div class="wrapper">
      <CallHelpTel></CallHelpTel>
      <div class="search">
        <div class="container">
          <a-input-search
            v-model:value="searchKeyword"
            @search="onSearch(searchKeyword)"
            placeholder="請輸入關鍵字"
            style="padding: 10px; border-radius: 15px"
            title="搜尋框"
          />
        </div>
      </div>
      <p :style="{ fontSize: fontSize.p + 'em' }" class="NumberOfSearches">
        共有{{ responseData.total }}項搜尋結果
      </p>
      <template v-for="item in responseData.list" :key="item.pageId">
        <VideoBlock
          v-if="item.nodeId === 37"
          :video="item"
          justify="VideoInner"
        />
        <ContentBlock
          v-else
          :article="item"
          :justify="switchPage(item.nodeId)"
        />
      </template>
      <a-pagination
        v-model:current="pagination.current"
        v-model:total="pagination.total"
        v-model:pageSize="pagination.pageSize"
        @change="onChange"
        :style="{ fontSize: fontSize.p + 'em' }"
      >
      </a-pagination>
    </div>
  </div>
</template>

<script>
//  無障礙文字子層引入設定
import { inject } from "vue";
import { useRoute } from "vue-router";
import CallHelpTel from "../components/Home/CallHelpTel.vue";
import VideoBlock from "../components/VideoContentB.vue";
import ContentBlock from "../components/ContentBlock.vue";
import { apiSearch } from "@/api/api.js";
import { ref, reactive } from "@vue/reactivity";
import { fakeImg } from "@/fake_data.js";

export default {
  name: "SearchRes",
  components: {
    CallHelpTel,
    ContentBlock,
    VideoBlock,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    const route = useRoute();
    const searchKeywordByHome = route.query.keyword;
    const searchKeyword = ref(searchKeywordByHome);
    const responseData = reactive({
      total: 0,
      list: [],
    });

    // 分頁資料
    const pagination = reactive({
      total: 0,
      current: 1,
      pageSize: 10,
    });

    // 搜尋功能
    const onSearch = (keyword) => {
      pagination.current = 1;
      apiSearch({
        keyword,
        page: 1,
      }).then((res) => {
        const totalCount = res.data.totalPage * 10;
        responseData.total = totalCount;
        pagination.total = totalCount;
        responseData.list = presenter(res.data);
      });
    };

    // 初始化頁面
    onSearch(searchKeywordByHome);

    // api 資料處理
    const presenter = ({ ...data }) =>
      data.homeResults.map((res) => {
        const img = res.path ? res.path : fakeImg;
        if (res.nodeId === 37)
          return {
            nodeId: res.nodeId,
            vid: res.id,
            title: res.title,
            originalFilePath: img,
            nodeName: res.nodeName,
            pageTitle: res.title,
            uploadDate: res.publishDate,
            abstract: res.content,
          };
        else {
          return {
            nodeId: res.nodeId,
            pageId: res.id,
            nodeName: res.nodeName,
            title: res.title,
            date: res.publishDate,
            content: res.content,
            image: res.path ? res.path : fakeImg,
            video: res.videoPath ?? "",
          };
        }
      });

    // 分類不同類型文章
    const switchPage = (nodeId) => {
      switch (nodeId) {
        case 37: // 影片
          return "VideoInner";
        case 184: // 專家建議
          return "ArticlePage";
        case 430: // 國際趨勢
        case 431: // 新聞轉載
          return "News_page";
        case 432: // 達人投稿
          return "SubmitPage";
        case 435:
        case 436:
        case 437:
          return "Employment";
        default:
          break;
      }
    };

    // 切換頁面
    const onChange = (clickPage) => {
      pagination.current = clickPage;
      apiSearch({
        keyword: searchKeyword.value,
        page: clickPage,
      }).then((res) => {
        responseData.list = presenter(res.data);
      });
    };

    return {
      responseData,
      switchPage,
      pagination,
      onChange,
      searchKeyword,
      onSearch,
      fontSize,
    };
  },
};
</script>
<!-- scope 沒有設定實驗 -->
<style lang="scss" scoped>
.NumberOfSearches {
  text-align: left;
  margin-left: 30px;
}
.search {
  padding-bottom: 40px;
  @include md {
    padding-bottom: 20px;
  }
  .ant-input-affix-wrapper {
    width: 35%;
    border: 1px solid #ccc;
    @include xl {
      width: 60%;
    }
    @include lg {
      width: 70%;
    }
    @include xs {
      width: 90%;
    }
  }
}
</style>
